export default "__VITE_ASSET__gTdozA1d__"